import { render } from "./Attribution.vue?vue&type=template&id=36a8001b&scoped=true"
import script from "./Attribution.vue?vue&type=script&lang=js"
export * from "./Attribution.vue?vue&type=script&lang=js"

import "./Attribution.vue?vue&type=style&index=0&id=36a8001b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36a8001b"]])

export default __exports__